<template>
  <label
    class="text-base font-medium text-gray-800 flex mb-0.5 items-center"
    :disabled="disabled"
    :class="labelClass"
  >
    <div class="flex-1">
      <slot>
        <span
          v-if="label"
          class="leading-tight "
        >
          <span v-if="label === 'x'">
          &nbsp;
          </span>
          <span v-else>{{ label }}:</span>
          <span
            v-if="required"
            v-tooltip="'Pflichtfeld'"
            class="sup font-normal text-red-500 ml-0.5"
          >*</span>
        </span>
        <span v-if="maxlength !== 524288">
          max. {{ maxlength }} Zeichen
        </span>
      </slot>
    </div>
    <div
      v-if="hasRight"
      class="flex-none"
    >
      <slot name="right" />
    </div>
  </label>
</template>
<script setup>
import { useProp } from '@/composables/useProp.js'
import { computed, useSlots } from 'vue'

const $slots = useSlots()
const hasRight = computed(() => !!$slots.right)

defineProps({
  label: useProp(String),
  labelClass: useProp(String),
  required: useProp(Boolean),
  disabled: useProp(Boolean),
  maxlength: useProp(Number, 524288)
})

</script>
